import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
const steps = [{
  step: 'Match the holder',
  copy: 'Choose the 1-inch SALXR 16-3D or 3/4-inch SALXR 12-3B system based on the machine and turret.'
}, {
  step: 'Choose the insert family',
  copy: 'Use MG12 roughing inserts for material removal, -30R chipbreakers when tighter chip control is the priority, or DR80 configurations for the published titanium starting range.'
}, {
  step: 'Share the application',
  copy: 'Provide the work material, machine model and horsepower, workholding, holder size, target depth of cut and feed, and expected quantity.'
}];
export function ToolSelection() {
  return <section aria-labelledby="tool-selection-heading" className="w-full border-t border-rule bg-white" data-id="element-337" data-mp="310cxxlluhuaz">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-10 lg:py-24" data-id="element-338" data-mp="2w0qe2tbihft7">
        <SectionHeading id="tool-selection-heading" eyebrow="SELECT THE SYSTEM" heading="Three decisions before the first cut" data-id="element-339" data-mp="3mh5ntuam7h0a" />

        <ol className="mt-12 border-t border-rule" data-id="element-340" data-mp="3r95fz0kg15mb">
          {steps.map((item, i) => <li key={item.step} className="grid gap-3 border-b border-rule py-7 md:grid-cols-[80px_minmax(0,1fr)_minmax(0,1.4fr)] md:items-baseline md:gap-8" data-id="element-341" data-mp="3di0qgrashtpp" data-mpi={i}>
              <span className="font-mono text-[11px] tracking-label text-copper" data-id="element-342" data-mp="a08pineodzfd">
                STEP {i + 1}
              </span>
              <h3 className="font-display text-[20px] font-medium leading-snug text-navy" data-id="element-343" data-mp="1jijpobhzdw">
                {item.step}
              </h3>
              <p className="rp-measure text-[15px] leading-[1.65] text-graphite/80" data-id="element-344" data-mp="4zupnsn89vsf">
                {item.copy}
              </p>
            </li>)}
        </ol>

        <Link to="/#product-guidance" data-analytics="product-guidance-cta" data-analytics-location="tool-selection" className="mt-10 inline-flex min-h-[52px] items-center gap-2 bg-navy px-7 text-[14.5px] font-semibold text-white transition-colors duration-150 ease-precise hover:bg-copper" data-id="element-345" data-mp="2pqlioj08uk72">
          Request Product Guidance
          <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-346" data-mp="1wu3w613r08ja" />
        </Link>
      </div>
    </section>;
}